<template>
	<div class="left_option">
		<span class="int_type_no_border"><select ref="dl" :class="className" v-bind:style="'width:' + width + 'px;' + codeStyleBoldStr"></select></span>
		<span v-if="showDesc" class="int_type2"><input ref="desc" v-model="desc" v-bind:style="'width:' + descWidth + 'px;' + descStyleBoldStr + colorStr" class="tbl_int sm_int" disabled="true" autocomplete="off"/></span>
		<span v-if="newMakable" style="margin-left:5px;"> <a href="javascript:;" class="gray_bt" @click="newCode()">New</a></span>
		<!-- <em class="lt_text">test{{ desc }}</em> -->
	</div>
	<!-- <input ref="dl" :class="className" v-bind:style="'width:' + width + 'px;'" /> -->
</template>

<script>
import { apiCheckCodeExists, apiInsertCodeSimple } from '@/api/basicinfo/code.js';

export default {
	data: function() {
		return {
			dl: null,
			desc: null,
		};
	},
	computed: {
		descStyleBoldStr() {
			return this.descBold ? 'font-weight:bold;' : '';
		},
		codeStyleBoldStr() {
			return this.codeBold ? 'font-weight:bold;' : '';
		},
		colorStr() {
			return 'color:' + this.fontColor + ';';
		},
	},
	props: {
		value: String,
		codes: Array,
		codeHeader: {
			type: String,
			default: 'Code',
		},
		nameHeader: {
			type: String,
			default: 'Name',
		},
		width: {
			type: Number,
			default: 80,
		},
		className: String,
		codeWidth: {
			type: Number,
			default: 80,
		},
		nameWidth: {
			type: Number,
			default: 200,
		},
		descWidth: {
			type: Number,
			default: 150,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		displayName: {
			type: Boolean,
			default: true,
		},
		displayDescription: {
			type: Boolean,
			default: false,
		},
		showDesc: {
			type: Boolean,
			default: true,
		},
		excludeCode: {
			type: String,
			default: null,
		},
		codeBold: {
			type: Boolean,
			default: false,
		},
		descBold: {
			type: Boolean,
			default: false,
		},
		fontColor: {
			type: String,
			default: 'black',
		},
		newMakable: {
			type: Boolean,
			default: false,
		},
		codeType: {
			type: String,
			default: null,
		},
	},
	watch: {
		codes: function(newVal) {
			this.loadData(newVal);
			if (this.codes.length > 0) this.$emit('post-loading');
		},

		value: function(newVal) {
			//console.log(this.codes, this.value);
			if (!newVal) {
				//console.log('null');
				this.dl.unSelectOption();
				this.desc = null;
			} else {
				//console.log('select', newVal, 'from ', this.codes.length + ' codes');
				this.dl.setComboValue(newVal);
				var code = this.getCode(newVal);
				if (code) {
					this.desc = code.name;
					if (code.description) this.desc = this.desc + ' (' + code.description + ')';
				} else this.desc = null;
			}
			this.$forceUpdate();
		},

		disabled: function(newVal) {
			//console.log(newVal);
			this.dl.disable(newVal);
		},
	},
	methods: {
		loadData() {
			//console.log(this.codes.length);
			this.dl.clearAll(true);
			var options = [];
			for (var i = 0; i < this.codes.length; i++) {
				if (!this.excludeCode || this.codes[i].code != this.excludeCode) {
					options.push({
						value: this.codes[i].code,
						text: {
							code: this.codes[i].code,
							name: this.codes[i].name,
							description: this.codes[i].description,
						},
					});
				}
			}
			this.dl.addOption(options);
		},
		getCode(value) {
			for (var i = 0; i < this.codes.length; i++) {
				if (this.codes[i].code == value) {
					return this.codes[i];
				}
			}
			return null;
		},
		async newCode() {
			//console.log('code type', this.codeType);
			var new_code = prompt('New Code', '');
			if (new_code) {
				new_code = new_code.toUpperCase().trim();
				if (new_code) {
					//console.log(new_code);
					if (await this.checkExists(new_code)) {
						this.$toast.error('Code Exists');
					} else {
						const { data } = await apiInsertCodeSimple({ code_type: this.codeType, code: new_code });

						if (data.result) {
							this.$toast.success('Saved successfully');
							var new_options = [];
							new_options.push({ value: new_code, text: { code: new_code, name: new_code, description: '' } });
							this.dl.addOption(new_options);
							this.dl.setComboValue(new_code);
						} else {
							this.$toast.error(data.msg);
						}
					}
				}
			}
		},
		async checkExists(code) {
			const { data } = await apiCheckCodeExists({ code_type: this.codeType, code: code });
			return data.result;
		},
	},
	mounted() {
		var vm = this;
		//console.log(this.codeBold, this.descBold);

		this.dl = new window.dhtmlXComboFromSelect(this.$refs.dl);
		if (!this.displayName) {
			this.dl.setTemplate({
				input: '#code#',
				header: true,
				columns: [{ header: this.codeHeader, width: this.codeWidth, option: '#code#' }],
			});
		} else if (this.displayDescription) {
			this.dl.setTemplate({
				input: '#code#',
				header: true,
				columns: [
					{ header: this.codeHeader, width: this.codeWidth, option: '#code#' },
					{ header: this.nameHeader, width: this.nameWidth, option: '#name#' },
					{ header: 'Description', width: 300, option: '#description#' },
				],
			});
		} else {
			this.dl.setTemplate({
				input: '#code#',
				header: true,
				columns: [
					{ header: this.codeHeader, width: this.codeWidth, option: '#code#' },
					{ header: this.nameHeader, width: this.nameWidth, option: '#name#' },
				],
			});
		}

		this.dl.disableAutocomplete();

		this.dl.setFilterHandler(function(mask, option) {
			var idx = option.text.name.toUpperCase().indexOf(mask.toUpperCase());
			var idx2 = option.text.code.toUpperCase().indexOf(mask.toUpperCase());

			return idx >= 0 || idx2 >= 0 ? true : false;
		});

		this.dl.enableFilteringMode(true);
		this.dl.setFontSize('124x', '14px');
		this.dl.attachEvent('onChange', function(value) {
			vm.$emit('input', value);
			vm.$emit('set-code', vm.getCode(value));
		});

		//console.log('value', this.value);

		//console.log(this.disabled);

		//console.log(this.excludeCode);
		this.dl.disable(this.disabled);

		// this.$nextTick(() => {
		// 	this.$forceUpdate();
		// });
	},
};
</script>

<style></style>
